import { KeyValue } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ExplorelogsService } from 'src/app/explore-logs/explorelogs.service';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { AlertsvarService, FactsheetEventsPanel, FactsheetSummaryPanel } from '../alertsvar.service';
import { AlertsService } from '../alerts-custom.service';
import { DesignerService } from 'src/app/designer/designer.service';
import { DashboardBuilderVarService } from 'src/app/designer/dashboard-builder-service/dashboard-builder-var.service';
import { SharedService } from 'src/app/services/shared.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ForceContinueComponent } from '../template/force-continue/force-continue.component';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { FormControl } from '@angular/forms';
import { getObjectDiff } from '@donedeal0/superdiff';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-alert-landing',
  templateUrl: './alert-landing.component.html',
  styleUrls: ['./alert-landing.component.scss']
})
export class AlertLandingComponent {

  constructor
  (
    private explorelogs:ExplorelogsService,
    private rcrumpService:RoutecrumpsService,
    public alertvarservice:AlertsvarService,
    private alertservice:AlertsService,
    private dashboardService: DesignerService,
    private dashboardbuildervarservice:DashboardBuilderVarService,
    public sharedService : SharedService,
    public matdialog: MatDialog,
    private cdkOverlyayService: CdkOverlyayService,
  ) { }

  $destroy: Subject<boolean> = new Subject();

  timeFilterIndex:number

  isSummaryFullscreen:boolean = false

  timeFilter = new FormControl()

  mat_landing_spinner=false

  force_view: boolean = false;

  dialogRef
  previewRef: any;

  @ViewChild('deduppop') deduppop: TemplateRef<any>;

  ngOnInit(){
    this.refreshAlertSummary()
    // this.alertvarservice.setdefaultAlertFilter()
    // this.requestAlertSummarydata(this.alertvarservice.mockRequest)
    // this.tabChange(0)
    // this.timeFilter.setValue([
    //   -1,
    //   "hour",
    //   24
    // ])
    
  }

  ngAfterViewInit(){

    

    // this.alertvarservice.alertSummaryTimeFilter.valueChanges
    // .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(500))
    // .subscribe((val)=>{
    //   // this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
    //   this.tabChange(this.alertvarservice.alertStatusSelectedIndex)
      


    // })
    // this.alertvarservice.alertTimeFilter.setValue([
    //   -1,
    //   "days",
    //   299
    // ])

    // this.alertvarservice.alertSummaryServerityFilter.valueChanges
    // .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(500))
    // .subscribe((val)=>{
    //   // this.isGlobalFilterActive = this.alertvarservice.checkGlobalFilterActive()
    //   // val?.forEach(filterval=>{
    //   //   this.alertvarservice.selectedFilters(this.sharedservice.severity_map,filterval)
    //   // })
    //   // this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
    //   this.tabChange(this.alertvarservice.alertStatusSelectedIndex)

    // })

    this.alertvarservice.alertStateFilter.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(1000))
    .subscribe((val)=>{

      if(val == null || val.length == 0) {
        // this.alertvarservice.alertStateFilter.setValue(["all"])
        this.alertvarservice.setStateFilter(this.alertvarservice.alertAnalystFilter.value)
      } else {
          this.alertvarservice.onalertStateChange(val,this.sharedService.state_map)
      }
      // this.tabChange(this.alertvarservice.alertStatusSelectedIndex)
      this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
    })

    this.alertvarservice.alertAnalystFilter.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged())
    .subscribe((val)=>{
// console.log({val})
// console.log(this.sharedService.analystlist)
      this.alertvarservice.setStateFilter(val)
      
    })

    this.alertvarservice.alertTimeFilter.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(1000))
    .subscribe((val)=>{
      // this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
      // this.tabChange(this.alertvarservice.alertStatusSelectedIndex)
      this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
      
    })

    this.alertvarservice.alertSeverityFilter.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(1000))
    .subscribe((val)=>{
      if(val == null || val.length == 0) {
        this.alertvarservice.alertSeverityFilter.setValue(["all"])
      }
      // this.tabChange(this.alertvarservice.alertStatusSelectedIndex)
      this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
      
      // this.tabChange(this.alertvarservice.alertStatusSelectedIndex)

    })

    this.alertvarservice.alertPlatformFilter.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged(),debounceTime(1000))
    .subscribe((val)=>{
      if(val == null || val.length == 0) {
        this.alertvarservice.alertPlatformFilter.setValue(["all"])
      }
      // this.tabChange(this.alertvarservice.alertStatusSelectedIndex)
      this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
      
    })

    

    this.alertvarservice.alertSummaryItemPerPage.valueChanges
    .pipe(takeUntil(this.$destroy),distinctUntilChanged())
    .subscribe((val)=>{
      this.alertvarservice.calcAlertPagination()
    })
  }


  async requestAlertSummarydata(dat: any) {
    this.alertvarservice.alertSummaryData = null;
    this.mat_landing_spinner=true
    this.alertvarservice.resetAlertPagination()
    this.alertservice.alertsummaryget.cancelRequest()
    // this.alertservice.alertsummaryget.cancelCall()
    await this.alertservice.alertsummaryget.postrequest(dat)
      .then((dat: any) => {
        if (dat.alertRows) { 
          // this.alertvarservice.alertSummaryData = dat;
          this.alertvarservice.allRows=dat.alertRows
            this.addAccordian(this.alertvarservice.allRows)
            // this.splitRows()
            
        }else{
          this.alertvarservice.allRows=[]
            this.addAccordian(this.alertvarservice.allRows)
            // this.splitRows()
        }
        // this.handleprovidealertdataerror.seterror(false, null);
        this.alertvarservice.calcAlertPagination()
        this.changeAlertStat(dat.alert_stat_summary)
        this.mat_landing_spinner=false
      })
      .catch(err => {
        // this.inProgress = false;
        this.alertvarservice.alertpagelength = 1;
        this.mat_landing_spinner=false
        // this.handleprovidealertdataerror.seterror(true, err.error?.errmsg);
      })
    this.alertvarservice.no_of_alerts = this.alertvarservice.alertRows.length
  }

  changeAlertStat(stats){
    Object.keys(this.alertvarservice.stats).forEach(key=>{
      this.alertvarservice.stats[key]["count"]=stats[key]?.["count"] ? stats[key]?.["count"] : 0
      this.alertvarservice.stats[key]["percentage"]=stats[key]?.["percentage"] ? stats[key]?.["percentage"] : 0
      this.alertvarservice.stats[key]["diff"]=stats[key]?.["diff"] ? stats[key]?.["diff"] : 0
    })
  }

  addAccordian(rows){
    this.alertvarservice.allRows.forEach(val=>{
      val["accordian"]=false
      val["timeRange"]=this.alertvarservice.alertTimeFilter.value
    })
  }

  refreshAlertSummary(){
    this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())
  }

  async tabChange(index){
    this.alertvarservice.alertStatusSelectedIndex = index;
    await this.requestAlertSummarydata(this.alertvarservice.buildAlertSummaryReqobj())

    // if(index == 0){
    //   this.changeStats(index,this.alertvarservice.triggeredRows)
    // }else if(index == 1){
    //   this.changeStats(index,this.alertvarservice.ackRows)
    // }else if(index == 2){
    //   this.changeStats(index,this.alertvarservice.waitingRows)
    // }else if(index == 3){
    //   this.changeStats(index,this.alertvarservice.reassignRows)
    // }else if(index == 4){
    //   this.changeStats(index,this.alertvarservice.allRows)
    // }

  }

  gotoPage(direction:number){
    if(this.alertvarservice.alertSummaryPageLength > 1 && !this.mat_landing_spinner){
      let current_pagenumber = this.alertvarservice.alertSummaryPageNumber;
      if(direction == 1){
        if(current_pagenumber < this.alertvarservice.alertSummaryPageLength){
          this.alertvarservice.alertSummaryPageNumber =  this.alertvarservice.alertSummaryPageNumber + 1
        }
      } else {
        if(current_pagenumber > 1){
          this.alertvarservice.alertSummaryPageNumber =  this.alertvarservice.alertSummaryPageNumber - 1
        }
      }
    }
    
  }

  // changeCount(event,i){

  //   console.log("Event =----> ",event)

  //   if(event.add){
  //     this.alertvarservice.allRows[i].alertcount += event.count
  //   }else{
  //     this.alertvarservice.allRows[i].alertcount -= event.count
  //   }

    
  // }

  openDedup(origin,alertId,status) {
    if(this.sharedService.getCurrentUserId() == this.alertvarservice.getAnalystFilterValue()){
      this.openEditPopup(this.deduppop,alertId,status)
    }
    
  }

  openEditPopup(template,alertId,status) {
    // this.alertvarservice.dedupId = alertId
    this.alertvarservice.dedupData.alertId=alertId
    this.alertvarservice.dedupData.status=status
    const dialogRef: MatDialogRef<any> = this.matdialog.open(template, {
      minWidth: '40vw',  
      minHeight: '17vh',
      maxWidth: '100%',
      maxHeight: '100%',
      width:'98%',
      height:'97%',
      disableClose:true
      // panelClass: 'resizable-dialog'
    });

    this.dialogRef = dialogRef

    this.alertvarservice.dedupDialogRef = dialogRef

    this.dialogRef._afterClosed.subscribe(val=>{
      this.alertvarservice.dedupData = {"alertId":"","status":0}
      if(val == "refresh"){
        this.refreshAlertSummary()
      }
// console.log("Close")
    })

  }

  openFullscreenAlertSummary(){
    this.isSummaryFullscreen = !this.isSummaryFullscreen
    
  }

 



  changeStats(index,rows){
// console.log(index,rows)
    if(rows.length){
      let critical = 0
      let high = 0
      let medium = 0
      let low = 0
      let total = 0

      rows.forEach(val=>{
        if(val.severity == 'critical'){
          critical += val.alertcount
        }else if(val.severity == 'high'){
          high +=val.alertcount
        }else if(val.severity == 'medium'){
          medium +=val.alertcount
        }else if(val.severity == 'low'){
          low +=val.alertcount
        }
        total += val.alertcount
      })
      this.alertvarservice.stats.critical.count = critical
      this.alertvarservice.stats.critical.percentage = Math.round((critical/total) * 100)
      this.alertvarservice.stats.high.count = high
      this.alertvarservice.stats.high.percentage = Math.round((high/total) * 100)
      this.alertvarservice.stats.medium.count = medium
      this.alertvarservice.stats.medium.percentage = Math.round((medium/total) * 100)
      this.alertvarservice.stats.low.count = low
      this.alertvarservice.stats.low.percentage = Math.round((low/total) * 100)
    }else{
      Object.keys(this.alertvarservice.stats).forEach(key=>{
        this.alertvarservice.stats[key].count=0
        this.alertvarservice.stats[key].percentage=0
      })
    }
  }

  openFactsheet_click(row: any) {

    // this.alertservice.lockAlert(row.alertId, this.force_view)
    //   .then(val => {


        // this.alertvarservice.alertscollapsedata.alertRowsData = [...this.alertvarservice.alertSummaryData.alertRows];




        this.alertvarservice.alertscollapsedata.alertRowsData = [...this.alertvarservice.allRows];
        this.alertvarservice.alertscollapsedata.selectedrows.next(row);
        this.alertvarservice.alertscollapsedata.selectedalert = row;
        this.alertvarservice.factSheetOpened = true;
        this.alertvarservice.summaryPanel = FactsheetSummaryPanel.collapse;
        this.alertvarservice.eventsPanel = FactsheetEventsPanel.collapse;
        this.alertvarservice.advancefilter_pannelexpanded = false;
        this.alertvarservice.alertEventSelectedIndex = 0;
        this.alertservice.getAlertsFields({ alertId: row.alertId, platform: row.platform })
          .subscribe((data: any) => {
            this.alertvarservice.eventFieldOptions = this.alertvarservice.processplatformFields(data.platform_fields);

          })





      // })
      // .catch((err) => {
      //   // console.log('err==');
      //   this.force_view = false;
      //   this.force_continue_alert(err.user_already_review, err.lattest_time, row);
      // })

  }

  force_continue_alert(user_already_review: string, lattest_time: string, row: any) {
    const termiateSessionDialogRef = this.matdialog.open(ForceContinueComponent, {
      width: "25vw", height: "24vh", data: { user_already_review, lattest_time }, autoFocus: false,
      disableClose: true
    })
    termiateSessionDialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.force_view = true;
        this.openFactsheet_click(row)
      } else {

      }
    })

  }

  getAlertTypeCount(status){
    let count = 0
    if(status == 0){
      count = this.alertvarservice.triggeredRows.length
    }else if(status == 1){
      count = this.alertvarservice.ackRows.length
    }else if(status == 3){
      count = this.alertvarservice.waitingRows.length
    }else if(status == 4){
      count = this.alertvarservice.reassignRows.length
    }else if(status == 6){
      count = this.alertvarservice.alltabRows.length
    }else{
      count = 0
    }
    return count
  }

  openAccordian(alertId,rows){
   
    rows.forEach(val=>{
      if(val.alertId == alertId){
        val.accordian = !val.accordian
        // console.log(val)
        if(val.accordian){
          this.getEvents(val)
        }
      }
    })
    
  }

  getEvents(row){
// console.log(row)
  }

  getPercent(count,rows){
    let total = 0
    
    rows.forEach(val=>{
      total += val.alertcount
    })

    let percent = (count*100)/total

    return Math.round(percent)
    
  }

  splitRows(){
    this.alertvarservice.triggeredRows=[]
    this.alertvarservice.ackRows=[]
    this.alertvarservice.waitingRows=[]
    this.alertvarservice.reassignRows=[]
    this.alertvarservice.alltabRows = []

    this.alertvarservice.allRows.forEach(val=>{
      if(val.status == 0){
        this.alertvarservice.triggeredRows.push(val)
      }else if(val.status == 1){
        this.alertvarservice.ackRows.push(val)
      }else if(val.status == 3){
        this.alertvarservice.waitingRows.push(val)
      } else if(val.status == 4){
        this.alertvarservice.reassignRows.push(val)
      } 
    })

    this.alertvarservice.alltabRows = this.combineAlerts(this.alertvarservice.allRows)
  }

  combineAlerts(alerts: any[]){
    const grouped = new Map<string, any>();
  
    for (const alert of alerts) {
      const existing = grouped.get(alert.alertId);
  
      if (!existing) {
        grouped.set(alert.alertId, { ...alert });
        continue;
      }
  
      existing.priority = Math.max(existing.priority, alert.priority);
      existing.lastAlertTime = Math.max(
        existing.lastAlertTime,
        alert.lastAlertTime
      );
  
      existing.alertcount += alert.alertcount;
      existing.eventcount += alert.eventcount;
  
      // Multiple objects with the same alertId
      // should have status as null
      existing.status = null;
    }
  
    return Array.from(grouped.values());
  }

  getLastSeen(epoch) {
    const diff = Math.floor(Date.now() / 1000) - epoch;
  
    if (diff < 60) return "just now";
  
    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} day${days !== 1 ? "s" : ""} ago`;
  
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
  
    const years = Math.floor(months / 12);
    return `${years} year${years !== 1 ? "s" : ""} ago`;
  }

  open_overlay(template: any, origin: any,index,rows) {
    let config = {
      data: {

        "template": template,

      }
    }
    this.previewRef = this.cdkOverlyayService.openPreview(config, TemplateDropdownComponent, origin);


    this.previewRef.$closed.subscribe(() => {

      if(getObjectDiff(rows[index].timeRange,this.timeFilter.value).status != "equal"){
        rows[index] = {
          ...rows[index],
          timeRange: this.timeFilter.value
        };
      }

      
      // console.log(rows)
      // console.log(this.alertvarservice.triggeredRows)
    })
  }

  updateSummary(action:string){
    if(action == "refresh"){
      this.refreshAlertSummary()
    }
  }

  openOverlay_templateRef(template: any, origin: any,index,rows): void {
    this.timeFilterIndex=index
    this.timeFilter.setValue(rows[index].timeRange)
    this.open_overlay(template, origin,index,rows)
  }

  resetFilter(){
    this.alertvarservice.resetGlobalFilter()
  }




  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  ngOnDestroy(){
    this.$destroy.next()
    this.$destroy.unsubscribe()
  }
}
